import { ACC_ID, GCLID, GRBAID, PLACEMENT, WBRAID } from "./constants";
import { sessionStorageKeys } from "./sessionStorageKeys";

export const COOKIES = [
    {
        key: "gclid",
        ringbaKeyName: GCLID,
        sessionStorageKey: sessionStorageKeys.gclid
    },
    {
        key: "grbaid",
        ringbaKeyName: GRBAID,
        sessionStorageKey: sessionStorageKeys.grbaid
    },
    {
        key: "wbraid",
        ringbaKeyName: WBRAID,
        sessionStorageKey: sessionStorageKeys.wbraid
    },
    {
        key: "acc_id",
        ringbaKeyName: ACC_ID,
        sessionStorageKey: sessionStorageKeys.acc_id
    },
    {
        key: "placement",
        ringbaKeyName: PLACEMENT,
        sessionStorageKey: sessionStorageKeys.placement
    },
]